export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

// Only the live production domain should report to GA — keeps preview/dev out.
const PROD_HOSTS = ['fortuneautodesign.com', 'www.fortuneautodesign.com'];

export function isAnalyticsReady() {
  return Boolean(
    GA_MEASUREMENT_ID &&
      typeof window !== 'undefined' &&
      typeof window.gtag === 'function' &&
      PROD_HOSTS.includes(window.location.hostname)
  );
}

export function trackPageView() {
  if (!isAnalyticsReady()) return;
  window.gtag('event', 'page_view', {
    page_title: document.title,
    page_location: window.location.href,
    ...(process.env.NODE_ENV === 'development' ? { debug_mode: true } : {}),
  });
}
